//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
let d=[[[0,"AngularTolerance",1,0],[0,"CleanUp",1,0],[0,"FacetBodyType",1,0],[0,"File",1,0],[0,"HideSmoothEdges",1,0],[0,"MinimumAngleFoldedFacets",1,0],[0,"MinimumFacetNumber",1,0],[0,"STLFileUnits",1,0],[0,"ShowInformationWindow",1,0]],[[["topologyCount"],"GetTopology",{R_:{topology:"Part[]"}},0,0]],[]];
SPLM.Facet.STLImportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.STLImportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.STLImportBuilder.AngularToleranceTypes = Object.freeze({
    "Coarse" : "Coarse", "Medium" : "Medium", "Fine" : "Fine"});

SPLM.Facet.STLImportBuilder.STLFileUnitsTypes = Object.freeze({
    "Meters" : "Meters", "Millimeters" : "Millimeters", "Inches" : "Inches"});

SPLM.Facet.STLImportBuilder.FacetBodyTypes = Object.freeze({
    "Psm" : "Psm", "Nx" : "Nx", "Jt" : "Jt"});

export default SPLM;